import { id } from 'date-fns/locale';
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  query,
  where,
  getDoc,
  orderBy,
  getCountFromServer,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import { createQuery, db } from "../providers/database";
import { JobDetailsNewCollection } from "../dataTypes/JobDetailsNewCollection";

import { collectionNames } from "./dictionary/collectionNames";
import { useQuery } from "react-query";
import { timeStamp } from 'console';



const event = collection(
  db,
  collectionNames.events,
);


export async function createNewEntryForEvents(
  eventData: any,
) {
  const data = {created_at: Timestamp.now(),...eventData}
  const newJob = await addDoc(event, {
  ...data,
  });
  return newJob.id;
}

export async function updateEntryForEvents(
  id: string,
  eventData: any
) {
  // Remove undefined fields before updating (optional but recommended)
  const cleanData: any = Object.fromEntries(
    Object.entries(eventData).filter(([_, v]) => v !== undefined)
  );

  try {
    const updated = await updateDoc(
      doc(db, collectionNames.events, id),
      cleanData
    );

    return updated; // returns void but indicates success
  } catch (error) {
    console.error("Error updating event entry:", error);
    throw error;
  }
}
export async function updateEventStatus(
  id: string,
  eventData: any
) {
  try {
    // only update required fields + timestamp
    const payload = {
      ...eventData,
      updated_at: Timestamp.now()
    };

    await updateDoc(doc(db, collectionNames.events, id), payload);

    return true;
  } catch (error) {
    console.error("Error updating event entry:", error);
    throw error;
  }
}




export function useGetActiveEvent() {
  return useQuery(
    ["All Events"],
    createQuery(() =>
      query(
        collection(db, collectionNames.events),
        where("status", "==", "active"),
      
      ),
    )
  );
}


export function useArchivedEvents() {
  return useQuery(
    ["Only Archived Events"],
    createQuery(() =>
      query(
        collection(db, collectionNames.events),
        where("status", "==", "archived"),
      ),
    ),

  );
}

/** All event/post documents (active + archived) for admin feed listing. */
export function useGetAllEvents() {
  return useQuery(
    ["All Events Admin"],
    createQuery(() => query(collection(db, collectionNames.events))),
  );
}


export function useGetEventById(id: string) {
  return useQuery({
    queryKey: ["eventById", id],
    queryFn: async () => {
      if (!id) return null;

      const ref = doc(db, collectionNames.events, id);
      const snap = await getDoc(ref);

      if (!snap.exists()) return null;

      return { id: snap.id, ...snap.data() };
    },
    enabled: !!id, // run only if id exists
  });
}

